module.exports = __webpack_public_path__ + "static/downloable/calendario_pagos_RPP_2025.58d1d58.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/calendario_pagos_RPP_2025.pdf
// module id = 59Hv
// module chunks = 1